import React, { useState, useEffect } from 'react';
import './Steps.css';

function Step3({ onNext }) {
  const [stage, setStage] = useState(0);
  const stages = [
    'Connecting…',
    'Syncing emotions…',
    'Matching frequencies…'
  ];

  useEffect(() => {
    const timers = [
      setTimeout(() => setStage(1), 1500),
      setTimeout(() => setStage(2), 3000),
      setTimeout(() => setStage(3), 4500)
    ];

    return () => timers.forEach(timer => clearTimeout(timer));
  }, []);

  return (
    <div className="step-container">
      <div className="step-content">
        <div className="emoji-large">💓</div>
        <h1 className="step-title">Step 3 – Heart Connection Test</h1>
        <h2 className="heading">📶 Establishing Connection…</h2>
        <p className="text">"Trying to connect to your heart…"</p>
        
        <div className="loading-section">
          {stage >= 0 && <p className="loading-text">{stages[0]}</p>}
          {stage >= 1 && <p className="loading-text">{stages[1]}</p>}
          {stage >= 2 && <p className="loading-text">{stages[2]}</p>}
        </div>

        {stage >= 3 && (
          <>
            <div className="result-box success">
              <p className="result-text">"Connection Stable ❤️</p>
              <p className="result-text">Signal Strength: Forever."</p>
            </div>
            <button className="btn btn-primary" onClick={onNext}>
              ➡ Proceed
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Step3;